var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "basic_text_material" },
    [
      _c("el-scrollbar", { staticStyle: { height: "calc(100vh - 70px)" } }, [
        _c("div", { staticClass: "text-preview-list" }, [
          _vm.$route.query.channelType != 4
            ? _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "title" }, [
                  _c(
                    "svg",
                    { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-haibaoxinxi16" },
                      }),
                    ]
                  ),
                  _vm._v("海报信息 "),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "text-item text-h1",
                    attrs: { draggable: "true" },
                    on: {
                      click: function ($event) {
                        return _vm.add_module(_vm.textStyle, "companyName")
                      },
                      dragend: function ($event) {
                        return _vm.dragend("textStyle", "companyName")
                      },
                    },
                  },
                  [_vm._v("企业简称")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "text-item text-h2",
                    attrs: { draggable: "true" },
                    on: {
                      click: function ($event) {
                        return _vm.add_module(_vm.textStyle, "gatewayName")
                      },
                      dragend: function ($event) {
                        return _vm.dragend("textStyle", "gatewayName")
                      },
                    },
                  },
                  [
                    _vm._v("门户名称 "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          content: "仅在招聘门户中生效",
                          placement: "top",
                        },
                      },
                      [_c("i", { staticClass: "icon iconfont icon-info14" })]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "text-item text-content",
                    attrs: { draggable: "true" },
                    on: {
                      click: function ($event) {
                        return _vm.add_module(_vm.textStyle, "userName")
                      },
                      dragend: function ($event) {
                        return _vm.dragend("textStyle", "userName")
                      },
                    },
                  },
                  [_vm._v("用户姓名")]
                ),
              ])
            : _vm._e(),
          ["imageText", "operatingActivities"].includes(_vm.$route.query.type)
            ? _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "title" }, [
                  _c(
                    "svg",
                    { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#icon-zhiweixinxi16" },
                      }),
                    ]
                  ),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$route.query.channelType == "4" ? "活动" : "职位"
                      ) +
                      "信息 "
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "text-item text-h1",
                    on: {
                      click: function ($event) {
                        return _vm.add_module(
                          _vm.h1Style,
                          _vm.$route.query.channelType == "4"
                            ? "activityName"
                            : "positionName"
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$route.query.channelType == "4" ? "活动" : "职位"
                      ) + "名称 "
                    ),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          content: "点击预览按钮切换查看单个职位/多个职位",
                          placement: "top",
                        },
                      },
                      [
                        _c("i", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$route.query.channelType != "4",
                              expression: "$route.query.channelType != '4'",
                            },
                          ],
                          staticClass: "icon iconfont icon-info14",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "text-item text-h2",
                    on: {
                      click: function ($event) {
                        return _vm.add_module(
                          _vm.textStyle,
                          _vm.$route.query.channelType == "4"
                            ? "activityInfo"
                            : "positionInfo"
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$route.query.channelType == "4"
                          ? "活动介绍"
                          : "职位信息"
                      ) + " "
                    ),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          content:
                            "单个职位时将展示职位概览信息，多个职位时不展示",
                          placement: "top",
                        },
                      },
                      [
                        _c("i", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$route.query.channelType != "4",
                              expression: "$route.query.channelType != '4'",
                            },
                          ],
                          staticClass: "icon iconfont icon-info14",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "content custom" }, [
            _c("div", { staticClass: "title" }, [
              _c(
                "svg",
                { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                [
                  _c("use", {
                    attrs: { "xlink:href": "#icon-zidingyiwenben16" },
                  }),
                ]
              ),
              _vm._v(" 自定义文本 "),
            ]),
            _c(
              "div",
              {
                staticClass: "text-item text-h1",
                attrs: { draggable: "true" },
                on: {
                  dragend: function ($event) {
                    return _vm.dragend("textStyle")
                  },
                },
              },
              [_vm._v("拖拽添加文本")]
            ),
            _c(
              "div",
              {
                staticClass: "text-item text-content",
                attrs: { draggable: "true" },
                on: {
                  dragend: function ($event) {
                    return _vm.dragend("contentStyle")
                  },
                },
              },
              [_vm._v("拖拽添加文本域")]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }